import { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getHomeAnalytics } from "services/MiscService";

// Format numbers with K, M, B, T
function formatNumber(num) {
  if (num >= 1_000_000_000_000) return (num / 1_000_000_000_000).toFixed(1) + "T";
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
  return num;
}

export default function HomeAnalytics() {
  const [analytics, setAnalytics] = useState({
    beneficiaries: 0,
    disbursed_amount: 0,
    total_institutions: 0,
  });

  const updateAnalytics = useCallback(async () => {
    const res = await getHomeAnalytics();
    if (res.data) {
      setAnalytics(res.data);
    }
  }, []);

  useEffect(() => {
    updateAnalytics();
  }, [updateAnalytics]);

  return (
    <section>
      <div className="max-w-[1196px] px-4 mx-auto my-8 gap-4 lg:gap-8 grid lg:grid-cols-4">
        <div className="bg-primary flex flex-col justify-center items-center text-white rounded-lg p-4 text-center">
          <p className="font-poppins lg:text-3xl">{formatNumber(9192 + analytics.beneficiaries)}+</p>
          <p className="font-poppins text-sm lg:text-base font-bold">Beneficiaries</p>
        </div>
        <div className="bg-primary flex flex-col justify-center items-center text-white rounded-lg p-4 text-center">
          <p className="font-poppins  lg:text-3xl">₦{formatNumber(1987355600 + analytics.disbursed_amount)}+</p>
          <p className="font-poppins text-sm lg:text-base font-bold">Loan Disbursed</p>
        </div>
        <div className="bg-primary flex flex-col justify-center items-center text-white rounded-lg p-4 text-center">
          <p className="font-poppins lg:text-3xl">{formatNumber(analytics.total_institutions)}+</p>
          <p className="font-poppins text-sm lg:text-base font-bold">Institutions</p>
        </div>
        <div className="bg-white shadow-lg rounded-xl p-4 flex flex-col justify-between hover:shadow-xl transition-shadow duration-300">
          <div>
            <p className=" text-sm lg:text-base  text-gray-500">
              Get insights into our loan statistics
            </p>
          </div>
          <NavLink
            to="/analytics/"
            className="mt-2 inline-block text-primary text-sm lg:text-base font-medium hover:underline"
          >
            See List of Beneficiaries →
          </NavLink>
        </div>
      </div>
    </section>
  );
}
